module.exports = __webpack_public_path__ + "img/speed_through_water.2f6f2a3e.svg";